import React from "react";
import InputKMQ from "../../UI/Input/InputKMQ";
import SelectKMQ from "../../UI/Select/SelectKMQ";
import TextArea from "../../UI/TextArea/TextArea";
import FileUpload from "../CplApplicantProfile/components/FileUpload";
import moment from "moment";

interface SubmittedCertificationSectionProps {
  certificates?: any[];
  editMode: boolean;
  updateCertificate: (index: number, field: string, value: any) => void;
  mapApiDocumentsToAttachments: (documents: any[]) => any[];
  monthOptions: { label: string; value: string }[];
  getYearOptions: () => { label: string; value: string }[];
}

const SubmittedCertificationSection: React.FC<SubmittedCertificationSectionProps> = ({
  certificates = [],
  editMode,
  updateCertificate,
  mapApiDocumentsToAttachments,
  monthOptions,
  getYearOptions
}) => {
  const getMonth = (date?: string) => {
    if (date) {
      return {
        label: moment(date).format('MMMM'),
        value: moment(date).format('MMMM')
      };
    }
    return null;
  };

  const getYear = (date?: string) => {
    if (date) {
      return {
        label: moment(date).format('YYYY'),
        value: moment(date).format('YYYY')
      };
    }
    return null;
  };

  if (!certificates.length) {
    return <div className="no-certificates">No certificates submitted</div>;
  }

  return (
    <div>
      <div className="edit-resume-education-title">Certifications</div>
      {certificates.map((cert: any, index: number) => (
        <div key={index} className="work-experience">
          <h4>Certification {index + 1}</h4>
          <InputKMQ
            value={cert.name ?? ""}
            label={"Certification Name"}
            onChange={(e) => editMode ? updateCertificate(index, 'name', e.target.value) : null}
            type="text"
            placeholder=""
          />
          <InputKMQ
            value={cert.certificate_issuer ?? ""}
            label={"Certificate Issuer"}
            onChange={(e) => editMode ? updateCertificate(index, 'certificate_issuer', e.target.value) : null}
            type="text"
            placeholder=""
          />
          <div className="submitted-certificate-resume-date">
            <SelectKMQ
              options={monthOptions}
              value={getMonth(cert.issue_date)}
              label={"Issue date"}
              placeholder={"Month"}
              onChange={(option) => {
                if (editMode) {
                  const year = getYear(cert.issue_date)?.value || moment().format('YYYY');
                  const newDate = moment(`${option.value} ${year}`, 'MMMM YYYY').format('YYYY-MM-DD');
                  updateCertificate(index, 'issue_date', newDate);
                }
              }}
            />
            <SelectKMQ
              options={getYearOptions()}
              value={getYear(cert.issue_date)}
              placeholder={"Year"}
              onChange={(option) => {
                if (editMode) {
                  const month = getMonth(cert.issue_date)?.value || moment().format('MMMM');
                  const newDate = moment(`${month} ${option.value}`, 'MMMM YYYY').format('YYYY-MM-DD');
                  updateCertificate(index, 'issue_date', newDate);
                }
              }}
            />
          </div>
          <InputKMQ
            value={cert.location ?? ""}
            label={"Location"}
            onChange={(e) => editMode ? updateCertificate(index, 'location', e.target.value) : null}
            type="text"
            placeholder=""
          />
          <InputKMQ
            value={cert.certificate_url ?? ""}
            label={"Certificate URL"}
            onChange={(e) => editMode ? updateCertificate(index, 'certificate_url', e.target.value) : null}
            type="text"
            placeholder=""
          />
          <TextArea
            value={cert.description ?? ""}
            label={"Certificate Description"}
            onChange={(e) => editMode ? updateCertificate(index, 'description', e.target?.value || e) : null}
            placeholder=""
          />

          {editMode && (
            <FileUpload
              onSave={(value) => {
                if (value && value.related_documents) {
                  updateCertificate(index, 'related_documents', value.related_documents);
                }
              }}
              // @ts-ignore
              files={mapApiDocumentsToAttachments(cert.related_documents)}
              optional={false}
              maxFiles={5}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default SubmittedCertificationSection;